import { render, staticRenderFns } from "./AirQualityInsights.vue?vue&type=template&id=2ecc4838"
import script from "./AirQualityInsights.vue?vue&type=script&lang=js"
export * from "./AirQualityInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports